import { type FC } from 'react';
import { useTranslation } from 'react-i18next';

import { useGetGameBoardQuery } from '@/api/queries/game';
import { useExtendedInfoQuery } from '@/api/queries/user';
import { AccumulationPhase } from '@/components/DiceGame/AccumulationPhase/AccumulationPhase';
import { Background } from '@/components/DiceGame/Background/Background';
import { Board } from '@/components/DiceGame/Board/Board';
import { DiceGameModals } from '@/components/DiceGame/DiceGameModals/DiceGameModals';
import { DiceGameProvider } from '@/components/DiceGame/DiceGameProvider';
import { RecoverDiceEnergyProvider } from '@/components/DiceGame/RecoverDiceEnergyProvider/RecoverDiceEnergyProvider';
import { ResourceTitle } from '@/components/ResourceTitle/ResourceTitle';

import css from './styles.module.scss';

const DiceGame: FC = () => {
  const { t } = useTranslation();
  const { data } = useGetGameBoardQuery();
  useExtendedInfoQuery();

  return (
    <DiceGameProvider>
      <DiceGameModals>
        <RecoverDiceEnergyProvider>
          <main className="w-full h-full relative overflow-hidden">
            <Background />
            <div className={css.diceWrapper}>
              <ResourceTitle>{t('Roll Craft')}</ResourceTitle>
              <div className="w-full flex flex-col relative grow">
                {data && (
                  <>{'board' in data ? <Board /> : <AccumulationPhase />}</>
                )}
              </div>
              {/* {data && <HowToPlayButton />} */}
            </div>
          </main>
        </RecoverDiceEnergyProvider>
      </DiceGameModals>
    </DiceGameProvider>
  );
};

export { DiceGame };
